// extracted by mini-css-extract-plugin
export var optionGrid = "_30-7";
export var optionList = "_30-6";
export var questionsBlock = "_30-9";
export var spacer = "_30-5";
export var stepCenteredContent = "_30-3";
export var stepInner = "_30-0";
export var stepInnerFullWidth = "_30-1";
export var stepInnerLockScroll = "_30-2";
export var stepTransitionFrame = "_30-4";
export var welcomeBlock = "_30-8";